// const auth = useContext(AuthContext)
//   const { userData } = auth
//   const userId= userData?.uid

// export const coinList = [
//   {
//     coinimg: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/bitcoin.svg`,
//     name: "Bitcoin",
//     price: "$5000",
//     quantity: "0.5",
//     buyprice: "$50,000",
//     usdvalue: "$25,000",
//   },
//   {
//     coinimg: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/etherium.svg`,
//     name: "Ethereum",
//     price: "$5000",
//     quantity: "0.5",
//     buyprice: "$50,000",
//     usdvalue: "$25,000",
//   },
//   {
//     coinimg: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/tether.svg`,
//     name: "USD Coin",
//     price: "$5000",
//     quantity: "0.5",
//     buyprice: "$50,000",
//     usdvalue: "$25,000",
//   },
//   {
//     coinimg: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/dai.svg`,
//     name: "Litecoin",
//     price: "$5000",
//     quantity: "0.5",
//     buyprice: "$50,000",
//     usdvalue: "$25,000",
//   },
//   {
//     coinimg: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/anchor.svg`,
//     name: "Ripple",
//     price: "$5000",
//     quantity: "0.5",
//     buyprice: "$50,000",
//     usdvalue: "$25,000",
//   },
//   {
//     coinimg: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/anchor.svg`,
//     name: "Ripple",
//     price: "$5000",
//     quantity: "0.5",
//     buyprice: "$50,000",
//     usdvalue: "$25,000",
//   },
//   {
//     coinimg: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/anchor.svg`,
//     name: "Ripple",
//     price: "$5000",
//     quantity: "0.5",
//     buyprice: "$50,000",
//     usdvalue: "$25,000",
//   },
//   {
//     coinimg: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/anchor.svg`,
//     name: "Ripple",
//     price: "$5000",
//     quantity: "0.5",
//     buyprice: "$50,000",
//     usdvalue: "$25,000",
//   },
//   {
//     coinimg: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/anchor.svg`,
//     name: "Ripple",
//     price: "$5000",
//     quantity: "0.5",
//     buyprice: "$50,000",
//     usdvalue: "$25,000",
//   },
//   {
//     coinimg: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/anchor.svg`,
//     name: "Ripple",
//     price: "$5000",
//     quantity: "0.5",
//     buyprice: "$50,000",
//     usdvalue: "$25,000",
//   },
//   {
//     coinimg: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/anchor.svg`,
//     name: "Ripple",
//     price: "$5000",
//     quantity: "0.5",
//     buyprice: "$50,000",
//     usdvalue: "$25,000",
//   },
// ];
export const apexData = [
  {
    coinane: "BTC",
    price: "45.00%",
    color: "#F6903D",
  },
  {
    coinane: "ETH",
    price: "25.00%",
    color: "#3DFFDC",
  },
  {
    coinane: "USDC",
    price: "15.00%",
    color: "#F26145",
  },
  {
    coinane: "LTC",
    price: "8.00%",
    color: "#268AFF",
  },
  {
    coinane: "LTC",
    price: "7.00%",
    color: "#5A3FFF",
  },
];
export const featureList = [
  {
    title: "Token",
    des: "Here is a description of this category ",
    num: "25",
  },
  {
    title: "DeFi",
    des: "Here is a description of this category ",
    num: "25",
  },
  {
    title: "NFT",
    des: "Here is a description of this category ",
    num: "25",
  },
  {
    title: "Chains",
    des: "Here is a description of this category ",
    num: "25",
  },
  {
    title: "CEX",
    des: "Here is a description of this category ",
    num: "25",
  },
  {
    title: "Features",
    des: "Here is a description of this category ",
    num: "25",
  },
];

export const postedData = [
  {
    title: "Improve Wallet Security ",
    des: "Implement additional security measures for better protection ...",
    coiname: "DeFi",
    status: "Completed",
    date: "04.30.23",
    profile: "User53",
    num: "20",
    color: "#30B601",
    status: "new",
  },
  {
    title: "Improve Wallet Security ",
    des: "Implement additional security measures for better protection ...",
    coiname: "DeFi",
    status: "Inprogress",
    date: "04.30.23",
    profile: "User54",
    num: "20",
    color: "#EDAC03",
    bgcolor: "#7D56E7",
    status: "completed",
  },
  {
    title: "Improve Wallet Security ",
    des: "Implement additional security measures for better protection ...",
    coiname: "DeFi",
    status: "Pending",
    date: "04.30.23",
    profile: "User53",
    num: "20",
    color: "#83818E",
    bgcolor: "#4A4950",
    status: "partial",
  },
  {
    title: "Improve Wallet Security ",
    des: "Implement additional security measures for better protection ...",
    coiname: "DeFi",
    status: "Completed",
    date: "04.30.23",
    profile: "User53",
    num: "20",
    color: "#30B601",
    status: "new",
  },
];
/*Central Exchange
DeFi
NFTs
Features
TAX
Others
*/
export const CategoryList = [
  {
    category: "Central Exchange",
    des: "CEX integration & features request",
  },
  {
    category: "DeFi",
    des: "Chains proposals",
  },
  {
    category: "NFTs",
    des: "Track and manage NFT portfolios",
  },
  {
    category: "Features",
    des: "Enhancements for better user experience",
  },
  {
    category: "TAX",
    des: "Simplify cryptocurrency tax reporting",
  },
  {
    category: "Others",
    des: "Innovative ideas and unique, support requests",
  },
];
export const voterList = [
  {
    profileImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/userprofile/profile.png`,
    name: "Ralph Edwards",
    wallet: "0x2aBcDeFgHiJkLmN",
  },
  {
    profileImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/userprofile/profile1.png`,
    name: "Wade Warren",
    wallet: "0x2aBcDeFgHiJkLmN34",
  },
  {
    profileImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/userprofile/profile2.png`,
    name: "Esther Howard",
    wallet: "0x2aBcDeFgHiJkLmN34",
  },
  {
    profileImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/userprofile/profile3.png`,
    name: "Esther Howard",
    wallet: "0x2aBcDeFgHiJkLmN34",
  },
  {
    profileImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/userprofile/profile4.png`,
    name: "Esther Howard",
    wallet: "0x2aBcDeFgHiJkLmN34",
  },
  {
    profileImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/userprofile/profile5.png`,
    name: "Esther Howard",
    wallet: "0x2aBcDeFgHiJkLmN34",
  },
  {
    profileImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/userprofile/profile6.png`,
    name: "Esther Howard",
    wallet: "0x2aBcDeFgHiJkLmN34",
  },
  {
    profileImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/userprofile/profile7.png`,
    name: "Esther Howard",
    wallet: "0x2aBcDeFgHiJkLmN34",
  },
];

export const defiList = [
  {
    defiDashboard: [
      {
        image: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/anchor.svg`,
        networkname: "All Networks",
        price: "$10,786,000",
      },
      {
        image: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/avalanche.png`,
        networkname: "Solana",
        price: "$987",
        prcent: "10%",
      },
      {
        image: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/binance.png`,
        networkname: "Uniswap",
        price: "$2312",
        prcent: "10%",
      },
      {
        image: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/cosmos.png`,
        networkname: "Cosmos",
        price: "$3535",
        prcent: "10%",
      },
      {
        image: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/polygon.svg`,
        networkname: "BNB Chain",
        price: "$3434",
        prcent: "10%",
      },
      {
        image: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/portfoliotracker.svg`,
        networkname: "Avalanche",
        price: "$545",
        prcent: "10%",
      },
      {
        image: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/solana.png`,
        networkname: "Polygon",
        price: "$5445",
        prcent: "10%",
      },
      {
        image: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/uniswap.png`,
        networkname: "Anchor",
        price: "$4545",
        prcent: "10%",
      },
      {
        image: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/dai.svg`,
        networkname: "Dai",
        price: "$545",
        prcent: "10%",
      },
    ],
  },
  {
    holdingList: [
      {
        image: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/dai.svg`,
        coinname: "DAI",
        symbol: "DAI",
        network: "BNB Chain",
        price: "$4545",
        quantity: "12133",
        value: "324324",
        change: "435345",
        profit: "true",
      },
      {
        image: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/uniswap.png`,
        coinname: "Uniswap",
        symbol: "UNI",
        network: "Etherium",
        price: "$4545",
        quantity: "12133",
        value: "324324",
        change: "435345",
        profit: "true",
      },
      {
        image: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/dai.svg`,
        coinname: "DAI",
        symbol: "DAI",
        network: "BNB Chain",
        price: "$4545",
        quantity: "12133",
        value: "324324",
        change: "435345",
      },
    ],
  },
  {
    stakingList: [
      {
        coinimgae: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/btc.svg`,
        coinname1: "WBTC",
        coinname2: "ETH",
        balance: "0.00 WBTC",
        balance1: "2,590 ETH",
        reward: "0.13 WBTC($2,180)",
        reward1: "1.78 ETH($2,227)",
        value: "$3248,45",
      },
      {
        coinimgae: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/btc.svg`,
        coinname1: "WBTC",
        coinname2: "ETH",
        balance: "0.00 WBTC",
        balance1: "2,590 ETH",
        reward: "0.13 WBTC($2,180)",
        reward1: "1.78 ETH($2,227)",
        value: "$3248,45",
      },
    ],
  },
  {
    dashData: [
      {
        boxName: "Current Balance",
        value: "$502,606.01",
        change: "4.52",
        profit: "true",
      },
      // {
      //   boxName: "Unrealized Gains",
      //   value: "$520,261.37",
      //   change: "2.14",
      //   profit: "false",
      // },
      // {
      //   boxName: "Best Performer",
      //   value: "Bitcoin",
      //   change: "10.72",
      //   profit: "true",
      //   icon: `${process.env.REACT_APP_IMAGE_BASE_URL}/coinlist/bitcoin.svg`,
      // },
    ],
  },
  {
    nftData: [
      {
        nftImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/nft/nft1.png`,
        name: "Makimono #454",
        price: "0,0386",
        fprice: "0,0386",
        change: "4.52",
        pl: "loss",
      },
      {
        nftImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/nft/nft2.png`,
        name: "Makimono #454",
        price: "0,0386",
        fprice: "0,0386",
        change: "4.52",
        pl: "profit",
      },
      {
        nftImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/nft/nft3.png`,
        name: "Makimono #454",
        price: "0,0386",
        fprice: "0,0386",
        change: "4.52",
        pl: "profit",
      },
      {
        nftImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/nft/nft4.png`,
        name: "Makimono #454",
        price: "0,0386",
        fprice: "0,0386",
        change: "4.52",
        pl: "profit",
      },
      {
        nftImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/nft/nft5.png`,
        name: "Makimono #454",
        price: "0,0386",
        fprice: "0,0386",
        change: "4.52",
        pl: "loss",
      },
      {
        nftImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/nft/nft6.png`,
        name: "Makimono #454",
        price: "0,0386",
        fprice: "0,0386",
        change: "4.52",
        pl: "profit",
      },
      // Add more NFT data objects as needed
    ],
  },
  {
    airdrop: [
      {
        nftImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/bgairdrop.png`,
        dropImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/nft/airdrop.png`,
        name: "Makimono #454",
        price: "2500",
        fprice: "386",
        change: "4.52",
        pl: "loss",
        process: "Ongoing",
      },
      {
        nftImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/bgairdrop.png`,
        dropImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/nft/airdrop2.png`,
        name: "Makimono #454",
        price: "2500",
        fprice: "386",
        change: "4.52",
        pl: "loss",
        process: "Completed",
      },
      {
        nftImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/bgairdrop.png`,
        dropImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/nft/airdrop3.png`,
        name: "Makimono #454",
        price: "2500",
        fprice: "386",
        change: "4.52",
        pl: "loss",
        process: "Unclaimed",
      },
      {
        nftImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/bgairdrop.png`,
        dropImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/nft/airdrop.png`,
        name: "Makimono #454",
        price: "2500",
        fprice: "386",
        change: "4.52",
        pl: "loss",
        process: "Ongoing",
      },
      {
        nftImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/bgairdrop.png`,
        dropImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/nft/airdrop2.png`,
        name: "Makimono #454",
        price: "2500",
        fprice: "386",
        change: "4.52",
        pl: "loss",
        process: "Completed",
      },
      {
        nftImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/bgairdrop.png`,
        dropImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/nft/airdrop3.png`,
        name: "Makimono #454",
        price: "2500",
        fprice: "386",
        change: "4.52",
        pl: "loss",
        process: "Unclaimed",
      },

      // Add more NFT data objects as needed
    ],
  },
  {
    handpick: [
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news1.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news2.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news3.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news4.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news5.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news6.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news7.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news8.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news4.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },

      // Add more news data objects as needed
    ],
  },
  {
    trending: [
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news1.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news2.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news3.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },

      // Add more news data objects as needed
    ],
  },
  {
    upcoming: [
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news1.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news2.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },
      {
        newsImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/news/news3.png`,
        time: "6 min read",
        date: "Nov 3, 2021",
        name: "The Rise of NFTs: Unlocking the Potential of Digital Assets",
        description:
          "The world of digital art and collectibles has undergone a revolutionary transformation with the advent of Non-Fungible Tokens (NFTs) collectibles has undergone a revolutionary.",
        author: "Jacob Jones",
        position: "Marketer ",
      },

      // Add more news data objects as needed
    ],
  },
];

// export const historyList = [
//   {
//     date: "2022/12/04 09:10:47",
//     hsh: "08cd3f7fc5d6fdb5d7eaa0fb2b871a6e5111d8",
//     status: "Receive",
//     rehsh: "4d7308cd3f7fc5d6fdb5d7eaa0fb2b871a6e5111d8",
//     value: "+ $10,000.00 DAI",
//     color: "#30B601",
//     fee: "0.00ETH",
//     fee1: "($0.73)",
//     image: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/receive.svg`,
//     images1: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/binance.png`,
//   },
//   {
//     date: "2022/12/04 09:10:47",
//     hsh: "24d7308cd3f7fc5d6fdb5d7eaa0fb2b871a6e5111d8",
//     status: "Remove",
//     rehsh: "d3f7fc5d6fdb5d7eaa0fb2b871a6e5111d8",
//     value: "+ $10,000.00 DAI",
//     color: "#E74238",
//     fee: "0.00ETH",
//     fee1: "($0.73)",
//     image: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/remove.svg`,
//     images1: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/binance.png`,
//   },
//   {
//     date: "2022/12/04 09:10:47",
//     hsh: "9824d7308cd3f7fc5d6fdb5d7eaa0fb2b871a6e5111d8",
//     status: "Contract Interaction",
//     rehsh: "308cd3f7fc5d6fdb5d7eaa0fb2b871a6e5111d8",
//     value: "+ $10,000.00 DAI",
//     color: "#E74238",
//     fee: "0.00ETH",
//     fee1: "($0.73)",
//     image: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/swap.png`,
//     images1: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/binance.png`,
//     images2: `${process.env.REACT_APP_IMAGE_BASE_URL}/defi/tsnimg.svg`,
//     nft: "+ 1 NFT Caked Apes #6565",
//   },
// ];


// --- Dynamic "How to add your asset" guides ---

export const DEFAULT_GUIDE = {
  title: "How to add your asset:",
  steps: [
    { title: "Choose", des: " an exchange, wallet, or address type from the list on the left", link: "https://blockstatshelp.zendesk.com/" },
    { title: "Follow", des: " the instructions", link: "https://blockstatshelp.zendesk.com/" },
  ],
};

export const INTEGRATION_GUIDES = {
  // Wallets
  "MetaMask": {
    title: "How to add your MetaMask Wallet:",
    steps: [
      { title1: "Enter", title: "connection name", des: " to recognize your wallet on portfolio page" },
      { title1: "Click on the", title: "“Connect”", des: " button" },
      { title1: "Log into your", title: "MetaMask", des: " account and select the ", title2: "network", des1: " in the window that opens" },
    ],
  },

  "Coinbase": {
    title: "How to add your Coinbase Exchange:",
    steps: [
      { title1: "Click the Connect button" },
      { title1: "You will be re-directed to the Coinbase website" },
      { title1: "Use your preferred method to login to Coinbase" },
      { title1: "Authorize and grant permission if prompted" },
    ],
  },

  "Binance": {
    title: "How to add your Binance Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36763551458067-Connecting-Binance-com-to-Blockstats",
    steps: [
      { title1: "Visit the Binance.us website and log in to your account" },
      { title1: "Select account in the top-right corner" },
      { title1: "Select API Management from the dropdown menu" },
      { title1: "If prompted, enable Two-Factor Authentication (2FA)" },
      { title1: "Click on Create a New API Key" },
      { title1: "Name the API key for easy identification (e.g., Blockstats)" },
      { title1: "Set the permissions to Read Only" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Input the API Key and API Secret you generated from Binance" },
      { title1: "Click the Connect button to link your Binance account with Blockstats" },
    ],
  },

  "Kucoin": {
    title: "How to add your Kucoin Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36764326115603-Connecting-KuCoin-to-Blockstats",
    steps: [
      { title1: "Visit the KuCoin website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select API Management from the dropdown menu" },
      { title1: "Click on Create a New API Key" },
      { title1: "Name the API key for easy identification (e.g., Blockstats)" },
      { title1: "Set a Passphrase and remember to save it" },
      { title1: "If prompted, enable Two-Factor Authentication (2FA)" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Input the API Key and API Secret and API Passphrase you generated from Kucoin" },
      { title1: "Click the Connect button to link your Kucoin account with Blockstats" },
    ],
  },

  "Binanceus": {
    title: "How to add your Binance Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36764434540435-Connecting-Binance-us-to-Blockstats",
    steps: [
      { title1: "Visit the Binance.us website and log in to your account" },
      { title1: "Select account in the top-right corner" },
      { title1: "Click on 'Export Reports' from the dropdown menu" },
      { title1: "For Tax report, click download under reports section on the right-hand side" },
      { title1: "Fill in the details and click Generate" },
      { title1: "Return to Blockstats and upload it via the provided file uploader" },
    ],
  },

  "Gemini": {
    title: "How to add your Gemini Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36763482036883-Connecting-Gemini-to-Blockstats",
    steps: [
      { title1: "Visit the Gemini website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select API Settings from the dropdown menu" },
      { title1: "Click on Create a New API Key" },
      { title1: "Name the API key for easy identification (e.g., Blockstats)" },
      { title1: "Set the permissions to Read Only" },
      { title1: "If prompted, enable Two-Factor Authentication (2FA)" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Once on Blockstats Input the API Key and API Secret you generated from Gemini" },
      { title1: "Click the Connect button to link your Gemini account with Blockstats" },
    ],
  },

  "LBank": {
    title: "How to add your Lbank Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36763423085587-Connecting-LBank-to-Blockstats",
    steps: [
      { title1: "Visit the Lbank website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select My API from the menu" },
      { title1: "Click on Create a New API Key" },
      { title1: "If prompted, enable Two-Factor Authentication (2FA)" },
      { title1: "Name the API key for easy identification (e.g., Blockstats)" },
      { title1: "Set the permissions to Read Only" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Once on Blockstats Input the API Key and API Secret you generated from Lbank" },
      { title1: "Click the Connect button to link your Lbank account with Blockstats" },
    ],
  },

  "Bingx": {
    title: "How to add your Bingx Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36763413922579-Connecting-BingX-to-Blockstats",
    steps: [
      { title1: "Visit the Bingx website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select API Management from the menu" },
      { title1: "Click on Create a New API Key" },
      { title1: "If prompted, enable Two-Factor Authentication (2FA)" },
      { title1: "Name the API key for easy identification (e.g., Blockstats)" },
      { title1: "Set the permissions to Read Only" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Once on Blockstats Input the API Key and API Secret you generated from Bingx" },
      { title1: "Click the Connect button to link your Bingx account with Blockstats" },
    ],
  },

  "Kraken": {
    title: "How to add your Kraken Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36763386818067-Connecting-Kraken-to-Blockstats",
    steps: [
      { title1: "Visit the Kraken website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select API from the menu" },
      { title1: "Click on Create a New API Key" },
      { title1: "Name the API key for easy identification (e.g., Blockstats)" },
      { title1: "Set the permissions to Read Only" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Once on Blockstats Input the API Key and API Secret you generated from Kraken" },
      { title1: "Click the Connect button to link your Kraken account with Blockstats" },
    ],
  },

  "HTX": {
    title: "How to add your HTX Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36763335083283-Connecting-HTX-to-Blockstats",
    steps: [
      { title1: "Visit the HTX website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select API Management from the menu" },
      { title1: "Click on Create a New API Key" },
      { title1: "Name the API key for easy identification (e.g., Blockstats)" },
      { title1: "Set the permissions to Read Only" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Once on Blockstats Input the API Key and API Secret you generated from HTX" },
      { title1: "Click the Connect button to link your HTX account with Blockstats" },
    ],
  },

  "Gate": {
    title: "How to add your Gate Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36763269767059-Connecting-Gate-io-to-Blockstats",
    steps: [
      { title1: "Visit the Gate.io website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select API Management from the menu" },
      { title1: "Click on Create a New API Key" },
      { title1: "Name the API key for easy identification (e.g., Blockstats)" },
      { title1: "Set the permissions to Read Only, and click Submit" },
      { title1: "Enable Two-factor Authentication (2FA) if prompted" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Once on Blockstats Input the API Key and API Secret you generated from Gate" },
      { title1: "Click the Connect button to link your Gate account with Blockstats" },
    ],
  },

  "Mexc": {
    title: "How to add your Mexc Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36763181763987-Connecting-MEXC-to-Blockstats",
    steps: [
      { title1: "Visit the Mexc website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select API Management from the menu" },
      { title1: "Click on Create a New API Key" },
      { title1: "Name the API key for easy identification (e.g., Blockstats)" },
      { title1: "Set the permissions to Read Only" },
      { title1: "Validate your Email and Phone Number as a part of the security measures" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Once on Blockstats Input the API Key and API Secret you generated from Mexc" },
      { title1: "Click the Connect button to link your Mexc account with Blockstats" },
    ],
  },

  "Bitstamp": {
    title: "How to add your Bitstamp Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36763101761555-Connecting-Bitstamp-to-Blockstats",
    steps: [
      { title1: "Visit the Bitstamp website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select Settings from the menu" },
      { title1: "In the left side menu, click on API Access" },
      { title1: "Generate a New API Key" },
      { title1: "Select Account Balance and User Transactions permissions" },
      { title1: "Activate the API Key, if prompted enable Two-Factor Authentication (2FA)" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Once on Blockstats Input the API Key and API Secret you generated from Bitstamp" },
      { title1: "Click the Connect button to link your Bitstamp account with Blockstats" },
    ],
  },

  "Bitflyer": {
    title: "How to add your Bitflyer Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36762722488083-Connecting-BitFlyer-to-Blockstats",
    steps: [
      { title1: "Visit the Bitflyer website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select API" },
      { title1: "Click on Generate New Key" },
      { title1: "Label the API key for easy identification (e.g., Blockstats)" },
      { title1: "Select only Assets option." },
      { title1: "Click OK to confirm" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Once on Blockstats Input the API Key and API Secret you generated from Bitflyer" },
      { title1: "Click the Connect button to link your Bitflyer account with Blockstats" },
    ],
  },

  "Bitget": {
    title: "How to add your Bitget Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36762573552019-Connecting-Bitget-to-Blockstats",
    steps: [
      { title1: "Visit the Bitget website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select API Keys from the dropdown menu" },
      { title1: "Click on Create API Key" },
      { title1: "If prompted, enable Two-Factor Authentication (2FA)" },
      { title1: "Name the API key for easy identification (e.g., Blockstats)" },
      { title1: "Set a Passphrase and remember to save it" },
      { title1: "Once generated, save the API key and API Secret and in a secure location" },
      { title1: "Input the API Key and API Secret and API Passphrase you generated from Bitget" },
      { title1: "Click the Connect button to link your Bitget account with Blockstats" },
    ],
  },

  "Coindcx": {
    title: "How to add your Coindcx Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36762497781395-Connecting-CoinDCX-to-Blockstats",
    steps: [
      { title1: "Visit the Coindcx website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select Security from the dropdown menu" },
      { title1: "Select API Dashboard" },
      { title1: "Click on Create a New API Key" },
      { title1: "If prompted, enable Two-Factor Authentication (2FA)" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Once on Blockstats Input the API Key and API Secret you generated from Coindcx" },
      { title1: "Click the Connect button to link your Coindcx account with Blockstats" },
    ],
  },

  "Coinspot": {
    title: "How to add your Coinspot Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36762283425299-Connecting-Coinspot-to-Blockstats",
    steps: [
      { title1: "Visit the Coinspot website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select API from the dropdown menu" },
      { title1: "If prompted, enable Two-Factor Authentication (2FA)" },
      { title1: "Click on Generate New Key" },
      { title1: "Label the API key for easy identification (e.g., Blockstats)" },
      { title1: "Once you have selected the permissions, generate the API Key" },
      { title1: "You will receive the API Key and Secret as a mail in you registered email address" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "On Blockstats Input the API Key and API Secret you generated from Coinspot" },
      { title1: "Click the Connect button to link your Coinspot account with Blockstats" },
    ],
  },

  "Crypto": {
    title: "How to add your Crypto Exchange:",
    link: "https://help.blockstats.app/hc/en-us/articles/36762193964179-Connecting-Crypto-com-to-Blockstats",
    steps: [
      { title1: "Visit the Crypto website and log in to your account" },
      { title1: "Click on your profile icon in the top-right corner" },
      { title1: "Select Security from the dropdown menu" },
      { title1: "Choose API Keys" },
      { title1: "Click on Create a New API Key" },
      { title1: "If prompted, enable Two-Factor Authentication (2FA)" },
      { title1: "Name the API key for easy identification (e.g., Blockstats)" },
      { title1: "Once generated, save the API key and API Secret in a secure location" },
      { title1: "Once on Blockstats Input the API Key and API Secret you generated from Crypto" },
      { title1: "Click the Connect button to link your Crypto account with Blockstats" },
    ],
  },

  "Suncrypto": {
    title: "How to connect Suncrypto Exchange:",
    link: "https://www.blockstats.app/blog/connect-suncrypto-to-blockstats-for-crypto-management",
    steps: [
      { title1: "Open the Suncrypto app and log in to your account" },
      { title1: "Tap the Profile icon in the top left corner of the dashboard" },
      { title1: "From the dropdown, select “Reports” to view available report types" },
      { title1: "Choose the appropriate report type based on your activity (e.g., Trading, Wallet, P2P)" },
      { title1: "Select the duration (e.g., Last 30 Days, Last Year, Custom Range)" },
      { title1: "The reports will be emailed to your registered email address in CSV format" },
      { title1: "Download the CSV files from your email" },
      { title1: "Return to Blockstats and upload it via the provided file uploader" },
    ],
  },

  "Flitpay": {
    title: "How to connect Flitpay Exchange:",
    link: "https://www.blockstats.app/blog/connect-flitpay-with-blockstats-for-crypto-tracking",
    steps: [
      { title1: "Open Flitpay and login to your account" },
      { title1: "Click the Profile icon in the top-right corner" },
      { title1: "Select “Wallet” from the dropdown" },
      { title1: "In the left sidebar, click on “Account Statement”" },
      { title1: "Select the Period" },
      { title1: "Click “Generate Report”" },
      { title1: "The report will be emailed to your registered email address in CSV format" },
      { title1: "Download the CSV file from your email" },
      { title1: "Return to Blockstats and upload it via the provided file uploader" },
    ],
  },


  "Delta": {
    title: "How to connect Delta Exchange:",
    link: "https://www.blockstats.app/blog/connect-delta-to-blockstats-for-crypto-portfolio-management",
    steps: [
      { title1: "Vist Delta Exchange website and login to your account" },
      { title1: "Click the Profile icon in the top-right corner" },
      { title1: "Select “API Keys” from the dropdown menu" },
      { title1: "Click “Create API Key” " },
      { title1: "Enable two-factor authentication (2FA) if prompted." },
      { title1: "Name your API key for identification purposes, like “Blockstats.” " },
      { title1: "Set permissions to “Read Only” to ensure security" },
      { title1: "Generate the key and copy both the API Key and Secret and store them securely" },
      { title1: "On Blockstats and paste the API Key and Secret you copied from Delta Exchange" },
      { title1: "Click the Connect button to link your Coindcx account with Blockstats" },
    ],
  },

  "CoinDCX": {
    title: "How to connect CoinDCX Exchange:",
    link: "https://www.blockstats.app/blog/connect-coindcx-with-blockstats-for-crypto-tracking",
    steps: [
      { title1: "Vist CoinDCX website and login to your account" },
      { title1: "Click the Profile icon in the top-right corner" },
      { title1: "Select API Dashboard on the left side panel" },
      { title1: "Click on Create new API Key" },
      { title1: "Copy the API key and API secret and store them securely" },
      { title1: "Name your API key for identification purposes, like “Blockstats.” " },
      { title1: "Set permissions to “Read Only” to ensure security" },
      { title1: "Generate the key and copy both the API Key and Secret and store them securely" },
      { title1: "On Blockstats and paste the API Key and Secret you copied from Delta Exchange" },
      { title1: "Click the Connect button to link your Coindcx account with Blockstats" },
    ],
  },

  "Mudrex": {
    title: "How to add your Mudrex exchange:",
    link: "https://www.blockstats.app/blog/connect-mudrex-with-blockstats-for-crypto-tracking",
    steps: [
      { title1: "Open the Mudrex mobile app and log in with your credentials" },
      { title1: "Tap on the Profile or user icon in the dashboard" },
      { title1: "Tap on Transaction Statement under the Reports and Statements section" },
      { title1: "In the Transaction Statement tab, choose your desired duration" },
      { title1: "Tap “Request Statement”" },
      { title1: "You will receive a CSV file in your registered email" },
      { title1: "Set permissions to “Read Only” to ensure security" },
      { title1: "Generate the key and copy both the API Key and Secret and store them securely" },
      { title1: "On Blockstats and paste the API Key and Secret you copied from Delta Exchange" },
      { title1: "Click the Connect button to link your Coindcx account with Blockstats" },
    ],
  },

  "Zebpay": {
    title: "How to connect Zebpay Exchange:",
    link: "https://www.blockstats.app/blog/connect-zebpay-with-blockstats",
    steps: [
      { title1: "Vist Zebpay website and login to your account" },
      { title1: "Click the Profile icon in the top-right corner" },
      { title1: "Choose “Statements” from the list of options." },
      { title1: "Selct the Trade option" },
      { title1: "Select the desired date" },
      { title1: "Click Submit" },
      { title1: "ZebPay will email the report in CSV format to your registered email" },
      { title1: "Locate and download the CSV file from your email inbox" },
      { title1: "Upload the report to Blockstats on the add assets page" },
      { title1: "Click the Connect button to link your Zebpay account with Blockstats" },
    ],
  },

  "Unocoin": {
    title: "How to connect Unocoin Exchange:",
    link: "https://www.blockstats.app/blog/connect-unocoin-to-blockstats-for-crypto-portfolio-management",
    steps: [
      { title1: "Vist Unocoin website and login to your account" },
      { title1: "Click on the “Wallet” tab on the left side panel" },
      { title1: "In the Cumulative tax Summary tab choose operation type as all" },
      { title1: "Select the desired date" },
      { title1: "Click Download" },
      { title1: "Save the downloaded reports" },
      { title1: "Upload the report to Blockstats on the add assets page" },
      { title1: "Click the Connect button to link your Unocoin account with Blockstats" },
    ],
  },

  "CUSTOMTXNS": {
    title: "Import Ledger / CSV Transactions",
    description: "Easily import your transaction history from Ledger or any custom CSV file.",
    // link: "https://blockstatshelp.zendesk.com/",
    downloadLink: "https://storage.googleapis.com/dev-prj-frontend-apps/static/docs/blockstats_sample_transactions.csv",
    supported: ["Ledger exports", "Custom transaction files", "Cold wallets & manual trades"],
    steps: [
      { title1: "Date", des: " – Transaction timestamp" },
      { title1: "Type", des: " – IN / OUT / TRADE / TRANSFER" },
      { title1: "In Asset & In Amount", des: " – Asset received" },
      { title1: "Out Asset & Out Amount", des: " – Asset sent" },
      { title1: "USD Values (In/Out)", des: " – Transaction value in USD" },
      { title1: "Fee Asset & Fee Amount", des: " – Transaction fees" },
      { title1: "TxID", des: " – Transaction identifier (optional but recommended)" },
    ],
  },

};

const normalize = (s = "") => s.trim().toLowerCase();

export const getGuideFor = (walletOrExchangeName, modeKey) => {
  if (!walletOrExchangeName) return DEFAULT_GUIDE;

  const wanted = normalize(walletOrExchangeName);

  // Try to find a guide whose key matches case-insensitively
  const matchedKey = Object.keys(INTEGRATION_GUIDES).find(
    k => normalize(k) === wanted
  );

  const guide = INTEGRATION_GUIDES[matchedKey] || DEFAULT_GUIDE;

  // Handle tab-specific guides, e.g. Coinbase's sync / csv / oauth tabs
  if (guide.modes) {
    return guide.modes[modeKey] || guide.modes.default || DEFAULT_GUIDE;
  }

  return guide;
};
